import {LegalDocumentPage} from 'attendee/LegalDocumentPage'
import React from 'react'
import {routes} from 'routes/routes'

export function PrivacyPolicy() {
  return (
    <LegalDocumentPage
      slug="privacy"
      routePath={routes.privacy}
      i18nPrefix="legal.privacy"
    />
  )
}
